import React, { useEffect, useRef } from 'react';
import _ from 'lodash';
import { connect, useSelector } from 'react-redux';
import { ErrorMessage, FastField, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { apiPost } from '../../../helpers/apiHelper';
import { carBrandNamesSelector } from '../../../modules/selectors/carBrands';
import { bindActionCreators } from 'redux';
import { fetchCarBrandsIfNeeded } from '../../../modules/actions/carBrands';
import { frontloadConnect } from 'react-frontload';
import { trackEvent } from '../Tracking/Matomo';
import Button from '../form-elements/Button';
import { InternalLink } from '../form-elements/Link';
import { markenStandortSelector } from '../../../modules/selectors/standort/markenStandort';
import { ContactPhone } from '../Meisterkachel/Contact';
import Select from '../form-elements/Select';

// const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
// const zipRegExp = /^[0-9]{5}$/;
// changed for requirements in TTP-2309
const phoneRegExp = /^[0-9]+$/;
const zipRegExp = /^[0-9]{4,5}$/;

function ContactForm({ carBrandNames, closeContactModal }) {
    const markenStandort = useSelector(markenStandortSelector);
    const productID = useSelector(state => state.productId?.data ?? '');

    const getLink = (link) => {
        let shopLink = link;
        if(link.includes('.localhost:3000')) {
            shopLink = link.replace('.localhost:3000', '');
        }
        return shopLink;
    }
    const focusRef = useRef();

    useEffect (() => {
        if (focusRef.current) {
            focusRef.current.focus();
        }
    }, []);

    const { implementsAreaConcept, areaShopSubLocations, nebenFabrikat, url } = markenStandort;
    // alle Marken oder wenn AreaShop: Marken aller Sublocations. Sonst Hauptfabrikat des Standorts.
    const carMakes =
        // (carBrandNames && carBrandNames.length > 0 && carBrandNames) ||
        (implementsAreaConcept && url === 'gottfried-schultz'
            ? areaShopSubLocations && _.uniq([...areaShopSubLocations.map(loc => loc.hauptFabrikat), ...nebenFabrikat])
            : implementsAreaConcept && url !== 'gottfried-schultz' ? areaShopSubLocations && _.uniq([...areaShopSubLocations.map(loc => loc.hauptFabrikat), ...nebenFabrikat]) : (carBrandNames && carBrandNames.length > 0 && carBrandNames));
    const initialValues = {
        serviceNotes: '',
        lastName: '',
        salutation: '',
        plz: '',
        contactBy: '',
        contact_email: '',
        contact_telephone: '',
        carMake: carMakes.length === 1 ? carMakes[0] : '',
        inquiryType: 'contactrequest',
        standortUrl: markenStandort.url || 'de',
        shopCurrentpage: getLink(window.location.href),
        articleNummer: productID,
    };

    const ContactSchema = Yup.object().shape({
        serviceNotes: Yup.string(),
        lastName: Yup.string().required('Pflichtfeld'),
        salutation: Yup.string(),
        zip: Yup.string().matches(zipRegExp, 'Bitte geben Sie eine valide Postleitzahl ein.'),
        contactBy: Yup.string(),
        contact_email: Yup.string().email('E-Mail ungültig').required('Pflichtfeld'),
        contact_telephone: Yup.string().matches(phoneRegExp, 'Bitte geben Sie eine valide Telefonnummer ein.'),
        carMake: Yup.string(),
        inquiryType: Yup.string(),
        standortUrl: Yup.string(),
        shopCurrentpage: Yup.string(),
        articleNummer: Yup.string(),
    });

    return (
        <div className="uk-width-xlarge uk-margin-auto contact_form_root">
            <div className="uk-panel uk-padding-small uk-background-secondary uk-light">
                <div className="uk-flex uk-flex-middle">
                    <h2 className="uk-margin-remove" aria-label="Kontakt Modal">Ihre Anfrage</h2>
                    <button
                        ref={focusRef}
                        className="uk-margin-auto-left uk-icon-button focus contact_close"
                        data-uk-icon="close"
                        onClick={closeContactModal}
                        data-uk-ttoltip="Kontakt schließen"
                        aria-label="Kontakt schließen"
                    />
                </div>
            </div>
            <div className="uk-padding-small uk-padding-remove-top" data-uk-margin="">
                <Formik
                    initialValues={initialValues}
                    validationSchema={ContactSchema}
                    onSubmit={(values, actions) => {
                        apiPost('/api/v1/ContactRequest', values, function (hasError) {
                            if (hasError) {
                                window.UIkit.notification('Beim senden ist ein Fehler aufgetreten.', {
                                    status: 'danger',
                                    pos: 'top-right',
                                });
                            } else {
                                trackEvent({
                                    category: 'Anfrage',
                                    action: 'Submit-Kontakt-Anfrage',
                                    label: values && values.standortUrl,
                                    standort: markenStandort,
                                });
                                window.UIkit.notification('Ihre Kontaktanfrage wurde erfolgreich verschickt.', {
                                    status: 'success',
                                    pos: 'top-right',
                                });
                            }
                            actions.setSubmitting(false);
                            actions.resetForm();
                            closeContactModal();
                            setTimeout(() => {
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                            }, 300);
                        });
                    }}
                    render={({ values, errors, touched, handleBlur, setFieldValue, isValid, isSubmitting }) => {
                        const onChange = ({ name, value }) => setFieldValue(name, value);
                        return (
                            <Form className="uk-form-stacked">
                                <h4 className="uk-text-bold">Wie können wir Ihnen helfen?</h4>
                                {markenStandort.anschrift && markenStandort.anschrift.telefon && (
                                    <div>
                                        <p>Rufen Sie uns an </p>
                                        <div className="uk-flex uk-flex-center">
                                            <ContactPhone phone={markenStandort.anschrift.telefon} hideArrow />
                                        </div>
                                    </div>
                                )}
                                <div className="uk-margin">
                                    <label className="uk-form-label" htmlFor="serviceNotes" style={{ fontSize: '1.4rem' }}>
                                        Nennen Sie uns Ihr Anliegen
                                    </label>
                                    <div className="uk-form-controls">
                                        <FastField
                                            component="textarea"
                                            className="uk-textarea"
                                            name="serviceNotes"
                                            id="serviceNotes"
                                            rows="5"
                                            placeholder="Beschreiben Sie Ihr Anliegen"
                                        />
                                    </div>
                                </div>
                                <hr />
                                <div>
                                    <h4>Kontaktdaten</h4>
                                    <p>
                                        Damit wir Ihnen schnellstmöglich bei Ihrem Anliegen weiterhelfen können, hinterlassen Sie uns bitte
                                        Ihre Kontaktdaten
                                    </p>
                                </div>
                                <div className="uk-margin">
                                    <label className="uk-form-label" htmlFor="salutation" style={{ fontSize: '1.4rem' }}>
                                        Anrede
                                    </label>
                                    <div className="uk-form-controls">
                                        <Select
                                            name="salutation"
                                            value={values.salutation}
                                            onBlur={handleBlur}
                                            onChange={onChange}
                                            options={[
                                                {
                                                    label: 'Anrede wählen',
                                                    value: '',
                                                },
                                                { label: 'Frau', value: 'Frau' },
                                                { label: 'Herr', value: 'Herrn' },
                                                { label: 'Divers', value: 'Divers' },
                                            ]}
                                            ariaLabel="Anrede"
                                        />
                                    </div>
                                </div>
                                <div className="uk-margin">
                                    <label className="uk-form-label" htmlFor="lastName" style={{ fontSize: '1.4rem' }}>
                                        Nachname *
                                    </label>
                                    <div className="uk-form-controls">
                                        <FastField
                                            className="uk-input"
                                            name="lastName"
                                            id="lastName"
                                            placeholder="Mustermann"
                                            required
                                            aria-required="true"
                                            aria-label="Nachname"
                                            autoComplete="family-name"
                                            aria-invalid={touched.lastName && errors.lastName ? "true" : "false"}
                                        />
                                        <ErrorMessage name="lastName">
                                            {msg => <div id="lastName-error" className="uk-text-danger" role="alert">{msg}</div>}
                                        </ErrorMessage>
                                    </div>
                                </div>
                                <div className="uk-margin">
                                    <label className="uk-form-label" htmlFor="contact_email" style={{ fontSize: '1.4rem' }}>
                                        E-Mail *
                                    </label>
                                    <div className="uk-form-controls">
                                        <FastField
                                            className="uk-input"
                                            name="contact_email"
                                            id="contact_email"
                                            type="email"
                                            placeholder="m.mustermann@internet.de"
                                            aria-label="E-Mail"
                                            required
                                            aria-required="true"
                                            autoComplete="email"
                                            aria-invalid={touched.contact_email && errors.contact_email ? "true" : "false"}
                                        />
                                        <ErrorMessage name="contact_email">
                                            {msg => <div id="contact_email-error" className="uk-text-danger" role="alert">{msg}</div>}
                                        </ErrorMessage>
                                    </div>
                                </div>
                                <div className="uk-margin">
                                    <label className="uk-form-label" htmlFor="contact_telephone" style={{ fontSize: '1.4rem' }}>
                                        Telefon
                                    </label>
                                    <div className="uk-form-controls">
                                        <div id="telephone-description" className="uk-text-meta">Bitte geben Sie Ihre Telefonnummer ohne Leerzeichen oder Sonderzeichen ein.</div>
                                        <FastField 
                                            className="uk-input" 
                                            name="contact_telephone" 
                                            id="contact_telephone"
                                            aria-label="Telefon"
                                            placeholder="1234 / 87654321"
                                            aria-describedby="Bitte geben Sie Ihre Telefonnummer ohne Leerzeichen oder Sonderzeichen ein."
                                            autoComplete="tel"
                                        />
                                        <ErrorMessage name="contact_telephone">
                                            {msg => <div id="contact_telephone-error" className="uk-text-danger" role="alert">{msg}</div>}
                                        </ErrorMessage>
                                    </div>
                                </div>
                                <div className="uk-margin">
                                    <label className="uk-form-label" htmlFor="zip" style={{ fontSize: '1.4rem' }}>
                                        Postleitzahl
                                    </label>
                                    <div className="uk-form-controls">
                                        <FastField
                                            className="uk-input"
                                            name="zip"
                                            id="zip"
                                            aria-label="Postleitzahl"
                                            placeholder="PLZ"
                                            aria-describedby="Bitte geben Sie Ihre fünfstellige Postleitzahl ein."
                                            autoComplete="postal-code"
                                            aria-invalid={errors.zip ? "true" : "false"}
                                        />
                                    </div>
                                </div>
                                <div className="uk-margin">
                                    <label className="uk-form-label" htmlFor="carMake" style={{ fontSize: '1.4rem' }}>
                                        Marke
                                    </label>
                                    <div className="uk-form-controls">
                                        <FastField
                                            component="select"
                                            className="uk-select"
                                            name="carMake"
                                            id="carMake"
                                            aria-label="Marke"
                                            placeholder="Marke"
                                            aria-invalid={errors.carMake ? "true" : "false"}
                                        >
                                            <option value="">Automarke wählen</option>
                                            {carMakes &&
                                                carMakes.map((carMake, index) => (
                                                    <option key={index} value={carMake}>
                                                        {carMake}
                                                    </option>
                                                ))}
                                        </FastField>
                                        <ErrorMessage name="carMake">
                                            {msg => <div id="carMake-error" className="uk-text-danger" role="alert">{msg}</div>}
                                        </ErrorMessage>
                                    </div>
                                </div>
                                <div className="uk-margin uk-grid-small uk-child-width-auto uk-grid">
                                    <div>
                                        Wir verarbeiten Ihre Daten entsprechend unserer&nbsp;
                                        <InternalLink
                                            to="/datenschutz"
                                            newTab
                                            aria-label="Datenschutzhinweise (öffnet in neuem Tab)"
                                        >
                                            <u>Datenschutzhinweise</u>
                                        </InternalLink>.
                                    </div>
                                </div>
                                <div className="uk-margin-bottom">* Pflichtfelder</div>
                                <Button 
                                    type="submit" 
                                    fullWidth 
                                    modifier="secondary"
                                    disabled={!isValid || isSubmitting}
                                    aria-disabled={!isValid || isSubmitting}
                                >
                                    Daten absenden
                                </Button>
                            </Form>
                        );
                    }}
                />
            </div>
        </div>
    );
}
const frontload = async ({ markenStandort, fetchCarBrandsIfNeeded }) => {
    if (markenStandort && markenStandort.showAllBrands) await fetchCarBrandsIfNeeded();
};
const mapDispatchToProps = dispatch => bindActionCreators({ fetchCarBrandsIfNeeded }, dispatch);

const mapStateToProps = state => ({
    carBrandNames: carBrandNamesSelector(state),
});
export default connect(mapStateToProps, mapDispatchToProps)(frontloadConnect(frontload)(ContactForm));
